import { render } from "./FooterApp.vue?vue&type=template&id=8589adf6&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"

import "./FooterApp.vue?vue&type=style&index=0&id=8589adf6&scoped=true&lang=scss"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8589adf6"]])

export default __exports__